/**
 * OpenStreetMap preview for pump coordinates (no extra dependencies).
 */
const PumpLocationMap = ({ latitude, longitude }) => {
  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);

  if (Number.isNaN(lat) || Number.isNaN(lng)) {
    return (
      <div className="border rounded p-3 text-muted small bg-light">
        Enter latitude and longitude to preview the pump location on the map.
      </div>
    );
  }

  const delta = 0.02;
  const bbox = [lng - delta, lat - delta, lng + delta, lat + delta].join(',');
  const embedUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`;
  const openUrl = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=15/${lat}/${lng}`;

  return (
    <div>
      <iframe
        title="Pump location map"
        src={embedUrl}
        className="w-100 border rounded"
        style={{ height: 220 }}
        loading="lazy"
      />
      <a href={openUrl} target="_blank" rel="noopener noreferrer" className="small">
        Open full map
      </a>
    </div>
  );
};

export default PumpLocationMap;
